"use client";

import { getUserData } from "../lib/User/action";
import { firestore } from "../firebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";
import * as Sentry from "@sentry/nextjs";
// import { identifyHotjarUser } from "../public/JavaScript/hotjar";
import useUserStore from "../lib/Store/useUserStore";
import { datadogRum } from "@datadog/browser-rum";

const useFirebaseLogging = () => {
    const { userData } = useUserStore();

    const logEventToFirebase = async (eventName, eventData = {}) => {
        // Fetch or create the anonymusId
        let anonymusId = Cookies.get("anonymusId");
        if (!anonymusId) {
            anonymusId = uuidv4(); // Generate a new UUID
            Cookies.set("anonymusId", anonymusId, { expires: 365 }); // Store it in cookies for 1 year
        }

        // Determine the IDs to use
        const userId = userData?.id || null; // If logged in, use the user's ID
        const effectiveId = userId || anonymusId; // Use userId if available, otherwise anonymusId

        const formattedDate = new Intl.DateTimeFormat("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        }).format(new Date());

        const formattedTime = new Intl.DateTimeFormat("en-US", {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        }).format(new Date());

        // Construct the event payload
        const eventPayload = {
            ...eventData,
            userId,
            anonymusId,
            effectiveId,
            date: formattedDate,
            time: formattedTime,
            debugLog: "",
            platform: "website",
            environment:
                process.env.NEXT_PUBLIC_ENV === "production"
                    ? "production"
                    : "development",
        };

        try {
            // Set the sentry user
            Sentry.setUser({
                id: userData?.id,
                email: userData?.email,
                username: anonymusId,
            });

            // Set the DataDog User
            datadogRum.setUser({
                id: userData?.id,
                email: userData?.email,
            });

            // @todo set the hotjar user
            // identifyHotjarUser(userData?.id, userData?.email, anonymusId);

            // Save the event in Firestore
            await addDoc(collection(firestore, "analyticsEvents"), {
                eventName,
                ...eventPayload,
            });
            console.log(`Event "${eventName}" logged successfully`);
        } catch (error) {
            console.error("Error logging event to Firebase:", error);
        }
    };

    return { logEventToFirebase };
};

export default useFirebaseLogging;
